import React, { useState } from 'react';
import { useProjects } from '../../hooks/useProjects';
import { useAuth } from '../../contexts/AuthContext';
import { projectService } from '../../services/projectService';
import ProjectForm from '../../components/Admin/ProjectForm';
import ProjectList from '../../components/Admin/ProjectList';
import SiteSettings from '../../components/Admin/SiteSettings';
import ProtectedRoute from '../../components/Auth/ProtectedRoute';
import './Admin.css';

const AdminContent = () => {
  const { projects, loading, error, refetch } = useProjects();
  const { logout } = useAuth();
  const [editingProject, setEditingProject] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setActiveTab] = useState('projects');

  const handleEditProject = (project) => {
    setEditingProject(project);
    setShowForm(true);
  };

  const handleAddProject = () => {
    setEditingProject(null);
    setShowForm(true);
  };

  const handleCloseForm = (changesMade = false) => {
    setShowForm(false);
    setEditingProject(null);
    if (changesMade) {
      refetch(); // Only refresh projects list if changes were made
    }
  };

  const handleToggleProperty = async (project) => {
    try {
      await projectService.updateProject(project.id, project);
      refetch(); // Refresh the projects list
    } catch (error) {
      console.error('Error updating project:', error);
      alert('Error updating project: ' + error.message);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (loading) {
    return (
      <div className="admin-container">
        <div className="admin-header-layout">
          <div className="admin-title">
            <h1>Admin Panel</h1>
          </div>
        </div>
        <div className="loading">Loading projects...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-container">
        <div className="admin-header-layout">
          <div className="admin-title">
            <h1>Admin Panel</h1>
          </div>
        </div>
        <div className="error">
          <h3>Error loading projects</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header-layout">
        <div className="admin-title">
          <h1>Admin Panel</h1>
          <div className="user-info">
            <span>personal@cgathmann.de</span>
          </div>
        </div>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>

      <div className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'projects' ? 'active' : ''}`}
          onClick={() => setActiveTab('projects')}
        >
          Projects
        </button>
        <button
          className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          Site Settings
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <ProjectForm
              project={editingProject}
              onClose={handleCloseForm}
              onRefresh={refetch}
            />
          </div>
        </div>
      )}

      <div className="admin-content">
        {activeTab === 'projects' && (
          <>
            <div className="tab-actions">
              <button
                onClick={handleAddProject}
                className="btn add-project-button"
              >
                Add New Project
              </button>
            </div>
            <ProjectList
              projects={projects}
              onEdit={handleEditProject}
              onToggleDraft={handleToggleProperty}
            />
          </>
        )}

        {activeTab === 'settings' && (
          <SiteSettings />
        )}
      </div>
    </div>
  );
};

const Admin = () => {
  return (
    <ProtectedRoute>
      <AdminContent />
    </ProtectedRoute>
  );
};

export default Admin;
